import request from '@/utils/request'

// --------------------货柜管理--------------------

/**
 * 货柜列表
 * @param {object} parameter
 */
export function getContainerList (parameter) {
  return request({
    url: `/ey230003/container/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 货柜详情
 * @param {object} parameter
 */
export function getContainerInfo (parameter) {
  return request({
    url: `/ey230003/container/getInfo/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询货柜可选设备类型
 * @param {object} parameter
 */
export function getSelectContainerPaneReplen (parameter) {
  return request({
    url: `/ey230003/container/selectContainerPaneReplen`,
    method: 'get',
    params: parameter
  })
}

/**
 * 新增货柜
 * @param {object} parameter
 */
export function addContainer (parameter) {
  return request({
    url: `/ey230003/container/insert`,
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑货柜
 * @param {object} parameter
 */
export function updateContainer (parameter) {
  return request({
    url: `/ey230003/container/update`,
    method: 'put',
    data: parameter
  })
}

// --------------------兑换记录--------------------

/**
* 根据货柜id查询货柜窗格列表
* @param {object} parameter
* @param {number} parameter.containerId
*/
export function getListByContainerId (parameter) {
  return request({
    url: `/ey230003/containerPane/listByContainerId`,
    method: 'get',
    params: parameter
  })
}

/**
 * 货柜-补货
 * @param {object} parameter
 */
export function supplyInventory (parameter) {
  return request({
    url: `/ey230003/containerPane/supplyInventory`,
    method: 'post',
    data: parameter
  })
}

/**
 * 货柜-分值设置
 * @param {object} parameter
 */
export function updateScore (parameter) {
  return request({
    url: `/ey230003/containerPane/updateScore`,
    method: 'post',
    data: parameter
  })
}

/**
 * 【货柜管理】兑换记录列表
 * @param parameter
 */
export function getContainerExchangeRecordList (parameter = {}) {
  return request({
    url: `/ey230003/ContainerExchangeRecord/list`,
    method: 'get',
    params: parameter
  })
}
